import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "wage-slip-broadcast-dialog" }
const _hoisted_2 = { class: "wage-slip-broadcast-dialog__header" }
const _hoisted_3 = ["disabled"]
const _hoisted_4 = { class: "wage-slip-broadcast-dialog__body" }
const _hoisted_5 = { class: "wage-slip-broadcast-dialog__month" }
const _hoisted_6 = ["disabled"]
const _hoisted_7 = ["value"]
const _hoisted_8 = {
  key: 0,
  class: "wage-slip-broadcast-dialog__error"
}
const _hoisted_9 = {
  key: 1,
  class: "wage-slip-broadcast-dialog__result-summary"
}
const _hoisted_10 = { class: "wage-slip-broadcast-dialog__footer" }

import { computed, ref, watch } from 'vue';
import LoadingOverlay from '@/components/common/LoadingOverlay.vue';
import { wageMagamApi } from '@/services/api';

const TEST_LONGTERM_CODE = '90000000011';
const TEST_CENTER_NAME = '이윤수방문요양';

type MemberLike = {
  m_name?: string;
  m_longterm_code?: string;
} | null;


export default /*@__PURE__*/_defineComponent({
  __name: 'YunsuTestWageSlipPrompt',
  props: {
    member: {},
    memberCode: {},
    bizGubun: {},
    yearMonth: {}
  },
  setup(__props: any) {

const props = __props;

const dialogOpen = ref(false);
const asked = ref(false);
const sending = ref(false);
const errorText = ref('');
const resultText = ref('');
const selectedYm = ref('');

const pad2 = (n: number) => String(n).padStart(2, '0');

const monthOptions = computed(() => {
  const list: { value: string; label: string }[] = [];
  let year = 2026;
  let month = 11;
  while (year < 2027 || (year === 2027 && month <= 12)) {
    list.push({
      value: `${year}${pad2(month)}`,
      label: `${year}년 ${month}월`,
    });
    month += 1;
    if (month > 12) {
      month = 1;
      year += 1;
    }
  }
  return list;
});

const isTestCenter = (member: MemberLike) => {
  if (!member) return false;
  const name = String(member.m_name || '').replace(/\s/g, '');
  const code = String(member.m_longterm_code || '').trim();
  return name === TEST_CENTER_NAME || code === TEST_LONGTERM_CODE;
};

const pickDefaultYm = () => {
  const current = String(props.yearMonth || '').replace(/\D/g, '').slice(0, 6);
  if (monthOptions.value.some((opt) => opt.value === current)) return current;
  return monthOptions.value[0]?.value || '';
};

const tryOpen = () => {
  if (asked.value || dialogOpen.value) return;
  if (!isTestCenter(props.member)) return;
  if (!props.memberCode || !props.bizGubun) return;
  asked.value = true;
  selectedYm.value = pickDefaultYm();
  errorText.value = '';
  resultText.value = '';
  dialogOpen.value = true;
};

watch(
  () => [props.member, props.memberCode, props.bizGubun, props.yearMonth],
  () => tryOpen(),
  { immediate: true }
);

const dismiss = () => {
  if (sending.value) return;
  dialogOpen.value = false;
};

const submitSend = async () => {
  if (!props.memberCode || !props.bizGubun || !selectedYm.value || sending.value) return;
  sending.value = true;
  errorText.value = '';
  try {
    const previewRes = await wageMagamApi.previewSlipBroadcast({
      mCode: props.memberCode,
      yearMonth: selectedYm.value,
      bizGubun: props.bizGubun,
    });
    if (!previewRes.data?.success) {
      errorText.value = previewRes.data?.message || '발송 대상을 확인하지 못했습니다.';
      return;
    }
    const matched = Array.isArray(previewRes.data.data?.matched) ? previewRes.data.data.matched : [];
    const targetCayIdxs = matched
      .map((row: { cayIdx?: number }) => Number(row.cayIdx))
      .filter((id: number) => Number.isFinite(id));
    if (!targetCayIdxs.length) {
      errorText.value = '해당 월 급여가 있는 소속 요양보호사가 없습니다.';
      return;
    }
    const opt = monthOptions.value.find((row) => row.value === selectedYm.value);
    const res = await wageMagamApi.sendSlipBroadcast({
      mCode: props.memberCode,
      yearMonth: selectedYm.value,
      bizGubun: props.bizGubun,
      title: `${opt?.label || selectedYm.value} 임금명세서`,
      targetCayIdxs,
    });
    if (!res.data?.success) {
      errorText.value = res.data?.message || '임금명세서 발송에 실패했습니다.';
      return;
    }
    const sent = Number(res.data.data?.sent || 0);
    const failed = Number(res.data.data?.failed || 0);
    resultText.value = failed
      ? `${sent}명 발송 · ${failed}명 실패했습니다.`
      : `${sent}명에게 ${opt?.label || ''} 임금명세서를 발송했습니다.`;
  } catch (error: any) {
    errorText.value =
      error.response?.data?.message || error.message || '임금명세서 발송에 실패했습니다.';
  } finally {
    sending.value = false;
  }
};

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createBlock(_component_v_dialog, {
    modelValue: dialogOpen.value,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((dialogOpen).value = $event)),
    "max-width": "480",
    persistent: ""
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(LoadingOverlay, {
          show: sending.value,
          text: "발송 중..."
        }, null, 8, ["show"]),
        _createElementVNode("div", _hoisted_2, [
          _cache[3] || (_cache[3] = _createElementVNode("span", null, "테스트 임금명세서 발송", -1)),
          _createElementVNode("button", {
            type: "button",
            class: "wage-slip-broadcast-dialog__close",
            disabled: sending.value,
            "aria-label": "닫기",
            onClick: dismiss
          }, [
            _createVNode(_component_v_icon, { size: "18" }, {
              default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                _createTextVNode("mdi-close", -1)
              ]))]),
              _: 1
            })
          ], 8, _hoisted_3)
        ]),
        _createElementVNode("div", _hoisted_4, [
          _cache[5] || (_cache[5] = _createElementVNode("p", { class: "wage-slip-broadcast-dialog__ask" }, "테스트 임금명세서를 발송하시겠습니까?", -1)),
          _cache[6] || (_cache[6] = _createElementVNode("p", { class: "wage-slip-broadcast-dialog__lead" }, " 소속 요양보호사 앱 채팅으로 보냅니다. 서류관리함에도 월별로 보관됩니다. ", -1)),
          _createElementVNode("div", _hoisted_5, [
            _cache[4] || (_cache[4] = _createElementVNode("label", { for: "yunsu-test-slip-month" }, "몇 월분을 보낼까요?", -1)),
            _withDirectives(_createElementVNode("select", {
              id: "yunsu-test-slip-month",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedYm).value = $event)),
              disabled: sending.value
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(monthOptions.value, (opt) => {
                return (_openBlock(), _createElementBlock("option", {
                  key: opt.value,
                  value: opt.value
                }, _toDisplayString(opt.label), 9, _hoisted_7))
              }), 128))
            ], 8, _hoisted_6), [
              [_vModelSelect, selectedYm.value]
            ])
          ]),
          (errorText.value)
            ? (_openBlock(), _createElementBlock("p", _hoisted_8, _toDisplayString(errorText.value), 1))
            : _createCommentVNode("", true),
          (resultText.value)
            ? (_openBlock(), _createElementBlock("p", _hoisted_9, _toDisplayString(resultText.value), 1))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createVNode(_component_v_btn, {
            variant: "text",
            class: "btn-close",
            disabled: sending.value,
            onClick: dismiss
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(resultText.value ? '닫기' : '나중에'), 1)
            ]),
            _: 1
          }, 8, ["disabled"]),
          (!resultText.value)
            ? (_openBlock(), _createBlock(_component_v_btn, {
                key: 0,
                variant: "flat",
                class: "btn-save",
                disabled: sending.value || !selectedYm.value,
                onClick: submitSend
              }, {
                default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
                  _createTextVNode(" 보내기 ", -1)
                ]))]),
                _: 1
              }, 8, ["disabled"]))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})